import React from "react";
import moment from "moment-timezone";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import {Button} from "reactstrap";
import CalendarToday from "@material-ui/icons/CalendarToday";
import {Link} from "react-router-dom";
import {freshdeskTicketDisplay, freshdeskTicketUrl, isPendingFreshdeskTicket} from "utils/freshdeskTicket";
import {feBookableTodayFilter} from "../../constants/feBookable";

/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has

 */
export default class TicketDetails extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Tickets._name);

	}

	loadSelfAfter() {
		super.loadSelfAfter();
		this.props.handle(this.state.customer, this.state.location, this.state.tickets_financialss.length > 0 ? this.state.tickets_financialss[0].pkey : null)
		if (typeof(this.props.setSignature) === 'function' && this.state.manager_override_signature) {
			this.props.setSignature(this.state.manager_override_signature_date, this.state.manager_override_signature)
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	form = () => {
		let {properties} = this.model
		let object = this.state
		let {loading} = this.state
		return (
			<div>
				<fieldset>
					<h4 className="section-title">Ticket Details</h4>
					<div className={"row"}>
						<div className={"col-md-3"}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Summary of Work"}
									value={object.summary}
									error={object.summary_error}
									property={properties.summary}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-md-3"}>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									property={properties.field_engineer}
									value={object.field_engineer}
									error={object.field_engineer_error}
									object={object.field_engineers}
									update={this.handleSelectPropertyUpdate}
									groupBy={this.state.customers_locations.region ?
										option => option.original.regions?.pkey === this.state.customers_locations.region ? "In Region" : "Out Of Region"
										:
										option => option.original.regions ? option.original.regions.name : "No Region Assigned"}
									requestOverride={"GET_FIELD_ENGINEERS"}
									filter={feBookableTodayFilter}
									limit={null}
									nullable={true}
									sort={"region"}
									text={"name_first&name_last"}
									firstGroup={"In Region"}
								/>
							</div>
						</div>
						<div className={"col-md-2"}>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									property={properties.type}
									value={object.type}
									error={object.type_error}
									object={object.tickets_types}
									update={this.handleSelectPropertyUpdate}
									order={'ASC'}
								/>
							</div>
						</div>
						<div className={"col-md-3"}>
							{isPendingFreshdeskTicket(object.fresh_ticket) ? (
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Freshdesk Ticket"}
										value={freshdeskTicketDisplay(object.fresh_ticket)}
										error={object.fresh_ticket_error}
										property={properties.fresh_ticket}
										update={this.handleTextFieldPropertyUpdate}
										disabled={true}
									/>
								</div>
							) : (
								<a href={freshdeskTicketUrl(object.fresh_ticket)} target={"_blank"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Freshdesk Ticket"}
											value={object.fresh_ticket}
											error={object.fresh_ticket_error}
											property={properties.fresh_ticket}
											update={this.handleTextFieldPropertyUpdate}
											disabled={true}
										/>
									</div>
								</a>
							)}
						</div>
						<div className={'col-md-1 flex-end text-right'}>
							<Link to={"/dispatch/calendar/" + object.pkey}>
								<Button color="primary" size={"sm"} onClick={() => {
									//so the window pops up
									localStorage.setItem('ticketToggled', 'no');
									localStorage.removeItem('users'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('regions'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('date'); //doing this so that ticket correctly pops after creation no matter what
								}}>
									To Calendar </Button>
							</Link>
						</div>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.description}
							value={object.description}
							error={object.description_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
					{this.renderWorkflowAttempts(object.workflow_attempts)}
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

	formatPhoenixDateTime = (value) => {
		if (value == null || value === '') {
			return '';
		}
		const stamp = moment(value).tz('America/Phoenix');
		return stamp.isValid() ? stamp.format('MM/DD/YYYY h:mm A') : '';
	};

	renderWorkflowAttempts = (attempts) => {
		const rows = Array.isArray(attempts) ? attempts : [];
		if (rows.length < 1) {
			return null;
		}
		return (
			<div className="form-group">
				<h4 className="section-title">Virus Removal / DISM / SFC Attempts</h4>
				<p>Helpdesk chronology from submitted attempts. Inline photos are prefixed with that step&apos;s Freshdesk text. Editing an existing Freshdesk note to attach images is not in this release.</p>
				<table className="table table-sm table-striped">
					<thead>
					<tr>
						<th>Process</th>
						<th>Stage</th>
						<th>#</th>
						<th>Outcome</th>
						<th>Notes</th>
						<th>When</th>
					</tr>
					</thead>
					<tbody>
					{rows.map((row, index) => (
						<tr key={row.pkey || index}>
							<td>{row.process || row.Process || ''}</td>
							<td>{row.stage || row.Stage || ''}</td>
							<td>{row.attempt_no || row.AttemptNo || ''}</td>
							<td>{row.outcome || row.Outcome || ''}</td>
							<td>{row.notes || row.Notes || ''}</td>
							<td>{this.formatPhoenixDateTime(row.occurred_at || row.OccurredAt)}</td>
						</tr>
					))}
					</tbody>
				</table>
			</div>
		);
	}

}

